export async function downloadFileFromApi(fileId: string | number): Promise<File | null> {
  const { apiBaseUrl } = useAppConfig()
  const { user, logout } = useUserStore()

  try {
    const response = await fetch(`${apiBaseUrl}files/${fileId}/download?t=${Date.now()}`, {
      method: 'GET',
      headers: {
        'X-Tenant': `${user.tenant_identifier}`,
        Authorization: `Bearer ${user.api_token}`,
        'Cache-Control': 'no-cache'
      },
      cache: 'no-store'
    })

    if (response.status === 401) {
      logout()
      return null
    }

    if (!response.ok) {
      try {
        const errorData = await response.json()
        const errorMessage = errorData?.data?.message || errorData?.message || response.statusText

        toast.value?.add({
          severity: 'error',
          detail: errorMessage,
          life: TOAST_LIFE_TIME_MS
        })
      } catch {
        toast.value?.add({
          severity: 'error',
          detail: `Failed to download file: ${response.statusText}`,
          life: TOAST_LIFE_TIME_MS
        })
      }

      return null
    }

    const blob = await response.blob()

    if (blob.size === 0) {
      toast.value?.add({
        severity: 'error',
        detail: 'Downloaded file is empty',
        life: TOAST_LIFE_TIME_MS
      })
      return null
    }

    const contentDisposition = response.headers.get('Content-Disposition')
    let filename = `file-${fileId}`

    if (contentDisposition) {
      const filenameMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/)
      if (filenameMatch && filenameMatch[1]) {
        filename = filenameMatch[1].replace(/['"]/g, '')
      }
    }

    return new File([blob], filename, { type: blob.type })
  } catch (error: any) {
    toast.value?.add({
      severity: 'error',
      detail: error?.message || 'Error downloading file',
      life: TOAST_LIFE_TIME_MS
    })

    return null
  }
}
